import { render, staticRenderFns } from "./ExtractCoin.vue?vue&type=template&id=1e814660&"
import script from "./ExtractCoin.vue?vue&type=script&lang=js&"
export * from "./ExtractCoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ExtractCoin.vue"
export default component.exports